import {
  NoteWrapper,
  RiskItem,
  RiskLabel,
  SuccessPlanCard,
  useSpContext,
} from "components/summary/success-plan";
import { SuccessPlanState } from "components/summary/success-plan/state/successPlan.types";
import moment from "moment-timezone";

type PartnerAssessmentSectionProps = {
  spState: SuccessPlanState;
};

const PartnerAssessmentSection = ({ spState }: PartnerAssessmentSectionProps) => {
  const { riskItems } = useSpContext();
  const { spData } = spState;
  const { partnerTeamRisk, partnerTeamRiskNote } = spData;
  const histories = spData.histories || [];

  const riskItem: RiskItem | undefined = riskItems.find((item) => item.value === partnerTeamRisk);
  const filteredHistories = histories.filter(
    (history: any) => history.fieldName === "partnerTeamRiskNote"
  );
  const noteHistories = filteredHistories.slice(1);
  const lastUpdatedOn =
    filteredHistories.length > 0
      ? moment(filteredHistories[0].lastModifiedDate)
          .tz("America/Los_Angeles")
          .format("YYYY-MM-DD HH:mm:ss PT")
      : "N/A";

  return (
    <SuccessPlanCard titleSlot="Partner Success Assessment">
      <RiskLabel riskItem={riskItem} />
      <NoteWrapper
        riskNote={partnerTeamRiskNote}
        noteHistories={noteHistories}
        lastUpdatedOn={lastUpdatedOn}
      />
    </SuccessPlanCard>
  );
};

export default PartnerAssessmentSection;
